import { axiosAiq } from 'config';

/**
 * Macaw images of a truck transaction: `{ id, version, image_category, camera_name, status, url, asset_id }`, where
 * `url` is a presigned S3 link, signed on every request and set only for READY images.
 *
 * @param {number|string} transactionId
 * @returns {Promise<Array>}
 */
export const getTransactionImages = async (transactionId) => {
    const response = await axiosAiq.get(`/transactions/trucks/${transactionId}/images`);
    return response.data;
};
